<div class="md-block" *ngIf="data.value || data.icon">
	<button class="md-block-icon" mat-icon-button matTooltip="{{ data.tooltip | translate }}: {{ data.id }}">
		<fitech-workspace-icon [iconKey]="data.icon"></fitech-workspace-icon>
	</button>
	{{ data.value }}
</div>
